"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _merchant = require("@/api/merchant");
var _batteryType = require("@/api/iot/batteryType");
var _branch = require("@/api/iot/branch");
var _default = {
  props: ['editItem', 'brandTypeList'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        member_id: '',
        battery_type: '',
        brand_type: '',
        prefix: '',
        voltage: '',
        can_use_electric: '',
        charge_voltage: '',
        charge_current: '',
        charge_electric_min: '',
        charge_electric_max: '',
        trickle: []
      },
      trickle: {
        trickle_charge_electric: 0,
        trickle_charge_temp: 0,
        // trickle_charge_voltage: 0,
        trickle_charge_current: 0
      },
      rules: {
        battery_type: [{
          required: true,
          message: '请输入电池类型',
          trigger: 'blur'
        }],
        brand_type: [{
          required: true,
          message: '请选择保护板类型',
          trigger: 'blur'
        }],
        prefix: [{
          required: true,
          message: '请输入分类前缀',
          trigger: 'blur'
        }],
        voltage: [{
          required: true,
          message: '请输入标称电压',
          trigger: 'blur'
        }]
      },
      subRules: {
        trickle_charge_electric: [{
          required: true,
          message: '请输入电量',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '不能小于0',
          trigger: 'blur'
        }],
        trickle_charge_temp: [{
          required: true,
          message: '请输入温度',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '不能小于0',
          trigger: 'blur'
        }],
        trickle_charge_voltage: [{
          required: true,
          message: '请输入电压',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '不能小于0',
          trigger: 'blur'
        }],
        trickle_charge_current: [{
          required: true,
          message: '请输入电流',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '不能小于0',
          trigger: 'blur'
        }]
      },
      merchantList: [],
      branchList: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '电池类型管理';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              if (key == 'trickle') {
                _this.form[key] = _this.editItem[key] ? _this.$func.deepClone(_this.editItem[key]) : [];
              } else {
                _this.form[key] = _this.editItem[key];
              }
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    reset: function reset() {
      // this.form.trickle = null
      console.log('this.form.trickle', this.form.trickle);
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    addTrickle: function addTrickle() {
      this.form.trickle.push((0, _objectSpread2.default)({}, this.trickle));
    },
    delTrickle: function delTrickle(index) {
      this.form.trickle.splice(index, 1);
    },
    submit: function () {
      var _submit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        var valid, len, i;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs['form'].validate().catch(function (err) {});
              case 2:
                valid = _context.sent;
                if (!(this.$refs['subForm'] && valid)) {
                  _context.next = 17;
                  break;
                }
                len = this.$refs['subForm'].length;
                i = 0;
              case 6:
                if (!(i < len)) {
                  _context.next = 17;
                  break;
                }
                if (!valid) {
                  _context.next = 13;
                  break;
                }
                _context.next = 10;
                return this.$refs['subForm'][i].validate().catch(function (err) {});
              case 10:
                valid = _context.sent;
                _context.next = 14;
                break;
              case 13:
                i = len;
              case 14:
                i++;
                _context.next = 6;
                break;
              case 17:
                if (!valid) {
                  _context.next = 21;
                  break;
                }
                (0, _batteryType.batteryTypeSave)(this.form).then(function (res) {
                  _this2.dialogVisible = false;
                  _this2.$emit('getList');
                });
                _context.next = 23;
                break;
              case 21:
                this.$message({
                  message: '请检查表单错误',
                  type: 'error'
                });
                return _context.abrupt("return", false);
              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }()
  }
};
exports.default = _default;